import { create } from 'zustand';
import { getOwnerById } from '../services/api';

const APTY_SALES_PAGE_RELOADED = 'APTY_SALES_PAGE_RELOADED';

const getUrlParameters = async (): Promise<{ partner: string, email: string }> => {
  const params = new URLSearchParams(window.location.search);
  const partner = params.get('partner') || '';
  const email = params.get('email') || '';
  // Not able to get partner and email from URL on first page load, so reload the page
  if ((!partner || !email) && !window.localStorage.getItem(APTY_SALES_PAGE_RELOADED)) {
    window.localStorage.setItem(APTY_SALES_PAGE_RELOADED, 'true');
    window.parent.postMessage({ action: 'APTY_SALES_PAGE_RELOAD' }, '*');
  } else {
    window.localStorage.removeItem(APTY_SALES_PAGE_RELOADED);
  }
  return { partner, email};
};

interface OwnerMap {
  [key: string]: string;
}

interface OwnersState {
  currentPartnerSalesRepEmail: string | null;
  currentPartnerName: string | null;
  owners: OwnerMap;
  loading: boolean;
  error: string | null;
  initializeOwner: () => Promise<void>;
  getOwnerName: (ownerId: string, accessToken: string) => Promise<string>;
}

export const useOwnersStore = create<OwnersState>((set, get) => ({
  currentPartnerSalesRepEmail: null,
  currentPartnerName: null,
  owners: {},
  loading: true,
  error: null,

  initializeOwner: async () => {
    try {
      const { partner, email } = await getUrlParameters();
      console.log("Loading Hubspot for partner", partner, "and email", email);
      set({
          currentPartnerSalesRepEmail: email,
          currentPartnerName: partner,
          loading: false
        });
    } catch (err: any) {
      set({ error: err.message, loading: false });
    }
  },

  getOwnerName: async (ownerId: string, accessToken: string) => {
    const { owners } = get();
    if (owners[ownerId]) {
      return owners[ownerId];
    } else {
      owners[ownerId] = 'Loading...';
    }

    try {
      const owner = await getOwnerById(ownerId, accessToken);
      const email = owner.email || `${owner.firstName} ${owner.lastName}`.trim();
      
      set({ owners: { ...get().owners, [ownerId]: email } });
      return email;
    } catch (error) {
      console.error(`Failed to fetch owner data for ID ${ownerId}:`, error);
      return ownerId;
    }
  }
})); 
